import { contactActionsOrder, contact } from '../services/ConfigService'
import isDelcoOrder from './liveChat.MenuLogDelcoRouting'
import TopLevelActionsModel, { ACTION_PRIMARY, ACTION_SECONDARY } from './topLevelActionsModel'

const displayChannels = []
const actionModel = TopLevelActionsModel
const isDdelcoOrder = isDelcoOrder()

const buttonType = () => (displayChannels.length === 0
  ? ACTION_PRIMARY
  : ACTION_SECONDARY)

const actionTitleKey = action => actionModel[action].titleKey

const actionDepartment = action => (isDdelcoOrder && contact[action].deliveryServiceDepartment
  ? contact[action].deliveryServiceDepartment
  : contact[action].department || null)

const actionTags = action => (isDdelcoOrder && contact[action].deliveryServiceTags
  ? contact[action].deliveryServiceTags
  : contact[action].tags || null)

/**
 * Contact actions Object from configuration as fallback
 * @param {Object} content Action Title translations
 * @returns {Object} Contact actions Object from configuration
 */
export default () => {
  for (let i = 0; i < contactActionsOrder.length; i++) {
    const action = contactActionsOrder[i]
    const enabled = contact[action] && contact[action].enabled

    if (enabled) {
      actionModel[action].titleKey = actionTitleKey(action)

      actionModel[action].buttonType = buttonType()

      actionModel[action].department = actionDepartment(action)

      actionModel[action].tags = actionTags(action)

      displayChannels.push(actionModel[action])
    }
  }

  return displayChannels
}
